import { render, staticRenderFns } from "./UiTriangleDown.vue?vue&type=template&id=0904710c&scoped=true"
import script from "./UiTriangleDown.vue?vue&type=script&lang=js"
export * from "./UiTriangleDown.vue?vue&type=script&lang=js"
import style0 from "./UiTriangleDown.vue?vue&type=style&index=0&id=0904710c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904710c",
  null
  
)

export default component.exports